export default "__VITE_ASSET__D6FfFOTM__"